import { db } from "../firebase";
import { doc, setDoc, getDoc,getDocs, collection, addDoc, updateDoc, deleteDoc , increment, arrayUnion } from "firebase/firestore";

export const AddBookToAuthorPublishedBooks = async (uid,isbnNumber) => {
    try {
        const subcollectionRef = collection(db, "users", uid, "publishedBooks");
            const docRef = doc(subcollectionRef,isbnNumber);
        await setDoc(docRef,{
            isbn:isbnNumber,

        })
        console.log("Book successfully added to the Author's Published works!");
    } catch (err) {
        console.error("Error adding book to Author published books: ", err);
        return null;
    }
}